import { useFormContext } from "react-hook-form";
import { DropdownFieldProps } from "./Dropdown.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { Label } from "@shadcn/components/ui/label";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shadcn/components/ui/select";

export const Dropdown = ({ label, config, required, validation, name, disabled }: DropdownFieldProps) => {
  const { control } = useFormContext();
  const description = getFieldHelperText(config.helperText, required);
  const validationConfig = getValidationConfig(validation);

  return (
    <FormField
      control={control}
      name={name}
      defaultValue={getDefaultValue()}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
      }}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            <Select
              onValueChange={field.onChange}
              value={field.value ?? getDefaultValue() ?? undefined}
              disabled={disabled}
            >
              <FormControl>
                <SelectTrigger id={name} aria-label={label}>
                  <SelectValue placeholder={config.placeholder} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {config.options?.map((option) => (
                  <SelectItem value={option.value} key={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );

  function getDefaultValue() {
    return config.options?.find((option) => option.isDefault)?.value;
  }
};